import { CustomCarousel } from '@internal/ui-common';
import { Incident } from '../types';
import { INCIDENT_CARD_SIZE } from '../incidentCard/incidentCard.style';
import { IncidentCard } from '../incidentCard/IncidentCard';
import { useStyles } from './incidentsCarousel.style';

import { useEffect, useMemo, useRef, useState } from 'react';

type IncidentsCarouselProps = {
  incidents: Incident[];
};

function IncidentsCarousel({ incidents }: IncidentsCarouselProps) {
  const { cx, classes } = useStyles();
  const incidentsCarouselRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number>(
    window.innerWidth,
  );

  useEffect(() => {
    if (incidentsCarouselRef.current) {
      setContainerWidth(incidentsCarouselRef.current.offsetWidth);
    }
  }, []);

  const incidentCardSizeInPixels = useMemo(
    () => parseFloat(INCIDENT_CARD_SIZE) * 16,
    [],
  );

  const incidentsPerCarouselPage = Math.floor(
    containerWidth / incidentCardSizeInPixels,
  );

  const groupedIncidents = incidents.reduce<Incident[][]>(
    (acc, incident, index) => {
      const groupIndex = Math.floor(index / incidentsPerCarouselPage);
      if (!acc[groupIndex]) {
        acc[groupIndex] = [];
      }
      acc[groupIndex].push(incident);
      return acc;
    },
    [],
  );

  return (
    <article data-testid="incident-cards-carousel">
      <CustomCarousel>
        {groupedIncidents.map(group => (
          <section
            ref={incidentsCarouselRef}
            key={`group-${group[0].incidentId}`}
            className={cx(classes.incidentsCarouselPageContent)}
          >
            {group.map(incident => (
              <IncidentCard
                key={incident.incidentId}
                incident={incident}
                data-testid={`incident-card-${incident.incidentId}`}
              />
            ))}
          </section>
        ))}
      </CustomCarousel>
    </article>
  );
}

export { IncidentsCarousel };
